<template>
	<div class="drawer">
		<el-drawer
		v-if="curRow._id"
		size="30%"
		title="预约详情"
		:visible.sync="drawerStatus"
		@close='handleClose'
		>
			<div style="padding-bottom:40px;">
				<el-row style="padding:40px 20px 0;float: none;font-size: 20px;">
					<el-col :span="22">
						<span class="label">顾客：</span>
						<span class="value">{{curRow.user_info.nick_name}}</span>
					</el-col>
				</el-row>
				<el-row style="padding:40px 20px 0;float: none;font-size: 20px;">
					<el-col :span="22">
						<span class="label">手机号：</span>
						<span class="value">{{curRow.user_info.user_mobile}}</span>
					</el-col>
				</el-row>
				<el-row style="padding:40px 20px 0;float: none;font-size: 20px;">
					<el-col :span="22">
						<span class="label">宠物：</span>
						<span class="value">{{curRow.pet_info.nick_name}}</span>
					</el-col>
				</el-row>
				<el-row style="padding:40px 20px 0;float: none;font-size: 20px;">
					<el-col :span="22">
						<span class="label">预约服务：</span>
						<span class="value">{{curRow.service_info.name}}</span>
					</el-col>
				</el-row>
				<el-row style="padding:40px 20px 0;float: none;font-size: 20px;">
					<el-col :span="22">
						<span class="label">预约日期：</span>
						<span class="value">{{$public.FTime(curRow.time_info.date,'YYYY-MM-DD')}}</span>
					</el-col>
				</el-row>
				<el-row style="padding:40px 20px 0;float: none;font-size: 20px;">
					<el-col :span="22">
						<span class="label">预约时间：</span>
						<span class="value">{{curRow.time_info.start_time}} - {{curRow.time_info.end_time}}</span>
					</el-col>
				</el-row>
				<el-row style="padding:40px 20px 0;float: none;font-size: 20px;">
					<el-col :span="22">
						<span class="label">医生/美容师：</span>
						<span class="value">{{curRow.service_info.operation_user_name}}</span>
					</el-col>
				</el-row>
				<el-row style="padding:40px 20px 0;float: none;font-size: 20px;">
					<el-col :span="22">
						<span class="label">预约状态：</span>
						<span class="value">
							{{curRow.states==0?'已删除':''}}
							{{curRow.states==1?'已预约':''}}
							{{curRow.states==2?'预约审核通过':''}}
							{{curRow.states==3?'预约完成':''}}
							{{curRow.states==-2?'取消预约':''}}
							{{curRow.states==-3?'预约审核失败':''}}
							{{curRow.states==-4?'预约成功未到':''}}
						</span>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="5" :offset="2" v-if="curRow.states==-3&&curRow.audit_info">
						<span class="label">审核失败原因：</span>
						<span class="value">{{curRow.audit_info.audit_remark}}</span>
					</el-col>
				</el-row>
				<el-row style="padding:40px 20px 0;float: none;font-size: 20px;" v-if="curRow.audit_info">
					<el-col :span="22">
						<span class="label">审核时间：</span>
						<span class="value">{{$public.FTime(curRow.audit_info.audit_time)}}</span>
					</el-col>
				</el-row>
				<el-row style="padding:40px 20px 0;float: none;font-size: 20px;" v-if="curRow.audit_info">
					<el-col :span="22">
						<span class="label">审核人：</span>
						<span class="value">{{curRow.audit_info.audit_user_name}}</span>
					</el-col>
				</el-row>
				<el-row style="padding:40px 20px 0;float: none;font-size: 20px;">
					<el-col :span="22">
						<span class="label">审核备注：</span>
						<span class="value">{{curRow.audit_info&&curRow.audit_info.audit_remark}}</span>
					</el-col>
				</el-row>
				<el-row style="padding:40px 20px 0;float: none;font-size: 20px;">
					<el-col :span="22">
						<span class="label">预约备注：</span>
						<span class="value">{{curRow.remarks}}</span>
					</el-col>
				</el-row>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
			}
		},
		computed:{
			userInfo(){
				if(this.$store.state.mendian.userInfo._id){
					return this.$store.state.mendian.userInfo;
				}else{
					return {
						basic_info:{},
						card_info:{},
						company_info:{},
						operation_info:{},
						pets_info:[],
						club_card:{}
					}
				}
			},
		},
		props:{
			curRow:{
				default:()=>{
					return {}
				}
			}
		},
		mounted(){
			this.$nextTick(()=>{
				this.drawerStatus = true;
			})
		},
		methods: {
			handleClose(){
				this.$emit('submit',{type:'close'})
			},
		},
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.label{
				display: inline-block;width:150px;text-align: right;
			}
		}
		
	}
	
</style>
